import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { reports } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'reports', element: <ModuleLayout />,
    handle: { title: i18n.t('reports.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'reports:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('reports.new'), permission: 'reports:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => reports.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (report: any) => (report && i18n.t('reports.edit', report)), permission: 'reports:update' },
      },
    ],
  },
];
